import React from 'react';
import Icon from '../icon/icon';
import * as s from './styled-stepper';

const StepperController = ({ activeStep, steps }) => (
  <s.Container>
    {steps.map((label, index) => {
      const completed = index < activeStep;
      const active = index === activeStep;
      return (
        <s.Step key={label}>
          {index > 0 && <s.Connector active={active} completed={completed} />}
          <s.IconWrapper active={active} completed={completed}>
            {completed ? <Icon name="check" size={14} strokeWidth={3} /> : <s.Circle />}
          </s.IconWrapper>
          <s.Label>{label}</s.Label>
        </s.Step>
      );
    })}
  </s.Container>
);

export default StepperController;
